// extracted by mini-css-extract-plugin
export default {"mode":"style_mode__Z-+nf","light":"style_light__MrXhy","dark":"style_dark__GmJ2y","ratioLeft":"style_ratioLeft__mKEv0","ratioRight":"style_ratioRight__R8Ftv"};